import { replace } from 'connected-react-router';

import apiSubmitPoll from '../../utils/poll/pollApi';
import { trackContent } from '../../utils/facebookPixel';

import {
    ACTION_COMPLETED_LOCAL_REP,
    SHOW_NEXT_ACTION_ANIMATION,
    IS_NEXT_ACTION_TRANSITION,
    onFinishMultiAction
} from '../Widget/actions';

export const POLL_SUCCESS = 'POLL_SUCCESS';
export const POLL_INITIATED = 'POLL_INITIATED';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';

export const onAnswerClick = (
    apiRequestData,
    answerId,
    answerText,
    actionIdentifier,
    actionCompletedTime,
    isMultiActionsCard,
    skipEndCard,
    questionText,
    isLastActionInWidget,
    showEmailInterstitial,
    onShowEmailInterstitial,
    answers,
    noOfAnswers,
    widgetId,
    actionInitiated,
    userAnswerId
) => dispatch => {
    if (!actionInitiated) {
        dispatch({
            type: POLL_INITIATED,
            payload: actionIdentifier
        });
    }

    if (showEmailInterstitial && (!skipEndCard || isLastActionInWidget)) {
        setTimeout(function() {
            onShowEmailInterstitial();
        }, 600);
    }

    var answerButton = document.querySelectorAll(
        "[data-answer='" + answerText.replace("'", "\\'") + "']"
    )[0];
    answerButton.classList.add('selected');
    answerButton.disabled = true;

    var dataAnswerVisible = document.querySelectorAll('[data-answer]');
    for (var i = 0; i < dataAnswerVisible.length; i++) {
        if (dataAnswerVisible[i].dataset.answer !== answerText) {
            dataAnswerVisible[i].disabled = true;
        }
    }

    trackContent('quiz', widgetId, actionIdentifier, questionText, answerId, answerText);

    apiSubmitPoll(
        apiRequestData,
        answerId,
        answerText,
        actionCompletedTime,
        skipEndCard,
        userAnswerId
    ).then(data => {

        dispatch({
            type: POLL_SUCCESS,
            payload: { ...data, answerId, actionIdentifier, questionText }
        });

        dispatch({
            type: SET_SUCCESS_INFO,
            payload: {
                questionText,
                answers,
                actionIdentifier,
                noOfAnswers
            }
        });

        if (!skipEndCard) {
            dispatch({
                type: IS_NEXT_ACTION_TRANSITION,
                payload: true
            });

            dispatch({
                type: SHOW_NEXT_ACTION_ANIMATION
            });
        }

        dispatch({
            type: ACTION_COMPLETED_LOCAL_REP
        });

        if (!showEmailInterstitial) {
            if (isMultiActionsCard) {
                onFinishMultiAction(actionIdentifier)(dispatch);
            } else if (isLastActionInWidget) {
                dispatch(replace('/poll/success'));
            } else if (!skipEndCard) {
                dispatch(replace('/poll/success'));
            }
        }

    });

    return true;
};
